export default __webpack_public_path__ + "static/media/Logo-png.1b672c02.png";